import { render } from "./FirstView012.vue?vue&type=template&id=5ad4c315&scoped=true"
const script = {}

import "./FirstView012.vue?vue&type=style&index=0&id=5ad4c315&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad4c315"]])

export default __exports__